"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerializableValidationError = void 0;
const SerializableError_1 = require("./SerializableError");
class SerializableValidationError extends SerializableError_1.SerializableError {
    constructor(error) {
        const errorMessage = error.map((validationError) => validationError.toString()).join('\n');
        super(errorMessage);
    }
}
exports.SerializableValidationError = SerializableValidationError;
